import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { breakpoints, palette } from '../../constants/styles';

export const Default = {
  container: css`
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    ${breakpoints.desktop} {
      justify-content: space-around;
    }
  `,
  item: css`
    color: gray;
    width: 42%;
    margin: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px;

    ${breakpoints.mobileLandscape} {
      margin: 8px;
    }

    ${breakpoints.tablet} {
      width: 41%;
      margin: 10px;
    }

    ${breakpoints.desktop} {
      width: 26%;
      margin: 15px 0px;
    }
    
    text-align: center;
    background-color: #ffffff;
    border-style: solid;
    border-width: 1px;
    border-radius: 20px;
    height: 100px;
  `,
  selected: css`
    border-color: #19CD19;
    background-color: rgba(101, 224, 101, 0.1);
  `,
};

export const ButtonLike = {
  container: css`
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.5rem;
  `,
  item: css`
    display: flex;
    justify-content: center;
    align-items: center;

    width: fit-content;
    min-width: 25px;

    margin: 0 5px 5px 0;
    padding: 0 10px;
    height: 35px;
    border: none;
    border-radius: 8px;
    background-color: ${palette.secondaryColor};
    border: 2px solid ${palette.secondaryColor};
    box-shadow: 2px 2px 15px -3px rgba(0,0,0,0.25);
    font-size: 1.2rem;
    line-height: 1.8;
    font-weight: 500;
    color: ${palette.white};
    cursor: pointer;
  `,
  selected: css`
    color: ${palette.secondaryActiveText};
    background-color: ${palette.secondaryActiveBg};
    border: 2px solid ${palette.secondaryActiveText};
  `,
};

export const ThemeShape = PropTypes.shape({
  container: PropTypes.array,
});
